import { Suspense, useRef } from 'react';

import AppErrorBoundaryWithFallback from '@/app/AppErrorBoundaryWithFallback';
import ClickOutside from '@/components/ClickOutside';
import Dropdown from '@/components/Dropdown';
import Placeholder from '@/components/Placeholder';
import UserSideList from '@/features/layout/components/UserSideList';

import { useMenu } from '../useMenu';
import UserSideButton from './UserSideButton';

/**
 *
 * Nav 우측에 위치한 유저 정보 적힌 메뉴 버튼
 */

const UserSide = () => {
  const personBtnRef = useRef();
  const { dropdown, onToggleDropdown, onRedirect } = useMenu();

  return (
    <ClickOutside
      isOpen={dropdown.person}
      toggleAreaRef={personBtnRef}
      onClickOutside={() => onToggleDropdown('person')}
    >
      <Dropdown
        dropSide="bottom-right"
        refElement={
          <Suspense fallback={<Placeholder className="h-5" />}>
            <AppErrorBoundaryWithFallback>
              <UserSideButton
                personBtnRef={personBtnRef}
                dropdown={dropdown}
                onToggleDropdown={onToggleDropdown}
              />
            </AppErrorBoundaryWithFallback>
          </Suspense>
        }
      >
        <UserSideList onRedirect={onRedirect} />
      </Dropdown>
    </ClickOutside>
  );
};

export default UserSide;
